import { TEXT } from "../configs/text";
import { AssessmentQuestion } from "./assessment";
import { QuizProps } from "./quiz";

export enum Session {
    vocab = 'vocab',
    lecture = 'lecture',
    practice = 'practice',
    practice2 = 'practice2',
    workbook = 'workbook',
    quiz = 'quiz',
    summary = 'summary',
    custom = 'custom'
}

export const sessionMap = {
    [Session.vocab]: TEXT.vocab,
    [Session.lecture]: TEXT.lecture,
    [Session.practice]: TEXT.practice,
    [Session.practice2]: TEXT.practice,
    [Session.workbook]: TEXT.workbook,
    [Session.quiz]: TEXT.quiz,
    [Session.summary]: TEXT.summary,
    [Session.custom]: TEXT.custom
}

export interface RewardPoint {
    id: number
    point: number
    section_code: string | null
    section_desc: string | null
    section_name: string | null
}

export interface ClassContent {
    [Session.vocab]: {
        is_active: number
        scormUrl: string
        vocabItems: VocabItem[]
    },
    [Session.lecture]: {
        id: number,
        videoUrl: string,
        questionUrl?: string,
        questions?: AssessmentQuestion[],
        state: number,
        type_code: string,
        scormUrl: string,
        is_active: number
    },
    [Session.workbook]: {
        id: number,
        url: string,
        scormUrl: string,
        is_active: number
    },
    [Session.practice]: {
        url: string
        is_active: number
    },
    [Session.practice2]: {
        url: string
        is_active: number
    },
    [Session.quiz]: QuizProps,
    [Session.summary]: {
        url: string
        is_active: number
    },
    [Session.custom]: {
        is_active: number
        section_code: string
        course_item_id: number | null
        custom_section_name: string | null
        custom_section_desc: string | null
    }
}

export interface VocabItem {
    id: number,
    word: string,
    word_phonetic: string,
    vocabVoiceUrl: string,
    contentExample: string,
    exampleVoiceUrl: string,
    illustrationUrl: string,
    state: number,
    status: string,
    desc: string,
}

export enum VocabRecordType {
    word = 1,
    example = 2
}

export enum VocabResultDecision {
    correct = 'correct',
    incorrect = 'incorrect',
    unanswered = 'unanswered',
    warning = 'warning'
}
export enum AttemptType {
    RELEVANT = 'RELEVANT',
    UNSPOKEN = 'UNSPOKEN',
    UNRELATED = 'UNRELATED'
}
export interface VocabResult {
    sentence: string,
    attempt_type: AttemptType,
    recording_quality: string,
    decision: VocabResultDecision,
    pronunciation_score: number,
    words: VocabResultWordItem[]
    key?: string | null
}
export interface VocabResultWordItem {
    phonemes: VocabResultWordPhonemesItem[]
}
export interface VocabResultWordPhonemesItem {
    text: string,
    ipa: string
    nativeness_score: number,
    decision: VocabResultDecision,
    feedback: VocabResultWordPhonemesItemFeedback[],
}
export interface VocabResultWordPhonemesItemFeedback {
    audio_link: string,
    id: number,
    language: string,
    text: string
}

export interface PracticeResult {
    completed: number
    quest_correct: number
    total_quest: number
    total_time: number
}

export enum PracticeDataType {
    update_item_info = 'update_item_info'
}

export interface PracticePostMessage extends MessageEvent {
    data: {
        type: PracticeDataType
        result: PracticeResult
    }
}

export interface PracticeResultMap {
    [Session.practice]: {
        [key: string]: {
            [key: string]: PracticeResult
        }
    },
    [Session.practice2]: {
        [key: string]: {
            [key: string]: PracticeResult
        }
    }
}

export interface VocabRecordAttempts {
    [key: string]: {//class roomname
        [key: string]: { // student username
            [key: number]: { //vocab id: attempts
                [key: number]: VocabResult[] //vocab record type (1:word|2:example)
            }
        }
    }
}